import dates from 'src/utils/dates'
import storage from '@/store/storage'

import actionNames from './actionNames'

const mutations = {
  isLoadingMainContent(state, isLoadingMainContent) {
    state.isLoadingMainContent = isLoadingMainContent
  },
  viewId(state, baseReportName) {
    const currentId = state.viewIds[baseReportName] || 0
    const viewId = currentId + 1

    state.viewIds = { ...state.viewIds, [baseReportName]: viewId }
  },
  columns(state, columns) {
    const seed = Object.keys(state.columns).reduce((newColumns, endpointKey) => {
      newColumns[endpointKey] = state.columns[endpointKey]
      return newColumns
    }, {})

    state.columns = Object.keys(columns).reduce((newColumns, endpointKey) => {
      newColumns[endpointKey] = columns[endpointKey]
      return newColumns
    }, seed)
  },
  adjuster(state, adjuster) {
    state.adjuster = adjuster
  },

  selected(state, selected) {
    state.selected = selected
  },

  reportPath(state, reportPath) {
    state.reportPath = reportPath
  },
  baseReportName(state, baseReportName) {
    state.baseReportName = baseReportName
  },
  routeName(state, routeName) {
    state.routeName = routeName
  },
  query(state, query) {
    state.query = query
  },
  metricPath(state, metricPath) {
    state.metricPath = metricPath
  },

  associationId(state, associationId) {
    state.associationId = associationId
  },
  subId(state, subId) {
    state.subId = subId
  },

  registerUnwatchReportFnsByDocId(state, { docId, fnUnwatchReport }) {
    state.unwatchReportFnsByDocId.push({ docId, fnUnwatchReport })
  },
  deregisterUnwatchReportFnsByDocId(state, unwatchIndex) {
    state.unwatchReportFnsByDocId.splice(unwatchIndex, 1)
  },

  reports(state, reports) {
    state.reports = reports
  },
  addReport(state, { groupKey, report }) {
    if (!state.reports[groupKey]) {
      state.reports[groupKey] = [report]
    } else {
      state.reports[groupKey].push(report)
    }
  },
  updateReport(state, { groupKey, report, reportIndex }) {
    state.reports[groupKey].splice(reportIndex, 1, report)
  },

  reportManager(state, reportManager) {
    state.reportManager = reportManager
  },
  temporaryReportOptions(state, temporaryReportOptions) {
    state.temporaryReportOptions = temporaryReportOptions
  },

  selectedIds(state, selectedIds) {
    state.selectedIds = selectedIds
  },

  searchData(state, searchData) {
    state.searchData = searchData
  },

  itemsPerPage(state, itemsPerPage) {
    state.itemsPerPage = itemsPerPage
  },
  page(state, page) {
    state.page = page
  },
  pageCount(state, pageCount) {
    state.pageCount = pageCount
  },

  dragging(state, dragging) {
    state.dragging = dragging
  },

  hasClickedToggler(state, hasClickedToggler) {
    state.hasClickedToggler = hasClickedToggler
  },
  isTogglingTables(state, isTogglingTables) {
    state.isTogglingTables = isTogglingTables
  },
  showRows(state, showRows) {
    state.showRows = showRows
  },

  displayAdvancedTools(state, displayAdvancedTools) {
    state.displayAdvancedTools = displayAdvancedTools
  },
  displayFilter(state, displayFilter) {
    state.displayFilter = displayFilter
  },
  applyingFilter(state, applyingFilter) {
    state.applyingFilter = applyingFilter
  },
  resettingFilter(state, resettingFilter) {
    state.resettingFilter = resettingFilter
  },

  filterData(state, filterReport) {
    const { filterData, baseReportName } = filterReport

    state.filterData[baseReportName] = { ...filterData[baseReportName] }
  },

  isCurrentlyAskingForDataFromTheApi(state, isCurrentlyAskingForDataFromTheApi) {
    state.isCurrentlyAskingForDataFromTheApi = isCurrentlyAskingForDataFromTheApi
  },

  items(state, { endpointKey, items, query }) {
    storage.set('ITEMS', { endpointKey, items, query })
  },
  results(state, { endpointKey, groups: items, query }) {
    storage.set('REPORT_RESULTS', { endpointKey, items, query })
  },
  metrics(state, { endpointKey, metrics: items, query }) {
    storage.set('METRICS', { endpointKey, items, query })
  },

  sorting(state, { endpointKey, sorting }) {
    state.sorting[endpointKey] = sorting
  },
  sorted(state, { direction, key, baseReportName }) {
    state.sorted[baseReportName] = { direction, key }
  },
  isSorting(state, { isSorting = false, baseReportName }) {
    state.isSorting[baseReportName] = isSorting
  },

  sortingByKeys(state, sortingByKeys) {
    state.sortingByKeys = sortingByKeys
  },
  sortingByDirections(state, sortingByDirections) {
    state.sortingByDirections = sortingByDirections
  },

  modalbar(state, modalbar) {
    state.modalbar = modalbar
  },
  modal(state, modal) {
    state.modal = modal
  },

  snackbar(state, snackbar) {
    state.snackbar = snackbar
  },
  snack(state, snack) {
    state.snack = snack
  },

  activePreFilters(state, { activePreFilters, baseReportName }) {
    state.activePreFilters = { ...state.activePreFilters, [baseReportName]: activePreFilters }
  },
  ignorePreFilters(state, { ignorePreFilters, baseReportName }) {
    state.ignorePreFilters = { ...state.ignorePreFilters, [baseReportName]: ignorePreFilters }
  },

  setSavedQuery(state, { baseReportName, summary }) {
    const { associationId, selectedSummary, subId, summaries } = state
    const reportSummary = selectedSummary[baseReportName]
    const havePreviousSummary = associationId && reportSummary[associationId] && (!subId || reportSummary[associationId][subId])
    const previousSummary = havePreviousSummary
      ? reportSummary[associationId][subId]
      : reportSummary

    const current = { ...summary }

    current.isDeactivating = false
    current.isActive = true
    current.isLoading = false

    const newSummaries = { ...summaries }
    const newSummary = associationId
      ? { [baseReportName]: { [associationId]: { [subId]: current } } }
      : { [baseReportName]: current }

    const { id: currSummaryId } = current

    if (previousSummary && previousSummary.id) {
      const previous = { ...previousSummary }
      const { id: prevSummaryId } = previous

      previous.isDeactivating = false
      previous.isActive = false
      previous.isLoading = false

      if (associationId) {
        newSummaries[baseReportName][associationId][subId][prevSummaryId] = previous
      } else {
        newSummaries[baseReportName][prevSummaryId] = previous
      }
    }

    if (associationId) {
      newSummaries[baseReportName][associationId][subId][currSummaryId] = current
    } else {
      newSummaries[baseReportName][currSummaryId] = current
    }

    state.summaries = newSummaries
    state.selectedSummary = { ...state.selectedSummary, ...newSummary }
  },
  removeSavedFilter(state, baseReportName) {
    const { associationId, selectedSummary, subId, summaries } = state

    const storedSummary = associationId
      ? selectedSummary[baseReportName][associationId][subId]
      : selectedSummary[baseReportName]
    const inactiveSummary = {
      isActive: false,
      isDeactivating: false,
      isLoading: false,
    }

    const { id: storedSummaryId } = storedSummary
    const stored = { ...storedSummary, ...inactiveSummary }
    const newSummaries = { ...summaries }
    const newSummary = { [baseReportName]: { [associationId]: { [subId]: stored } } }

    if (associationId) {
      newSummaries[baseReportName][associationId][subId][storedSummaryId] = stored
    } else {
      newSummaries[baseReportName][storedSummaryId] = stored
    }

    state.summaries = newSummaries
    state.selectedSummary = { ...state.selectedSummary, ...newSummary }
  },

  infoModal(state, requestedInfo) {
    state.infoModal = requestedInfo
  },
  isInfoModalVisible(state, visibility) {
    state.isInfoModalVisible = visibility
  },

  [actionNames.GET_SUMMARY_REQUESTED](state, { baseReportName, summary }) {
    const { associationId, subId, summaries, summaryDefaults } = state

    const savedSummaries = { ...summaries }
    const { id: summaryId } = summary

    summary.isLoading = true
    summary.didFail = false

    if (associationId) {
      if (!savedSummaries[baseReportName][associationId]) {
        const defaults = summaryDefaults[baseReportName]

        savedSummaries[baseReportName][associationId] = { [subId]: { ...defaults } }
      }

      savedSummaries[baseReportName][associationId][subId][summaryId] = summary
    } else {
      savedSummaries[baseReportName][summaryId] = summary
    }

    state.summaries = savedSummaries
  },
  [actionNames.GET_SUMMARY_SUCCEEDED](state, { baseReportName, summary }) {
    const { associationId, subId, summaries, summaryDefaults } = state

    const savedSummaries = { ...summaries }
    const { id: summaryId } = summary

    summary.isLoading = false
    summary.didFail = false

    if (associationId) {
      if (!savedSummaries[baseReportName][associationId]) {
        const defaults = summaryDefaults[baseReportName]

        savedSummaries[baseReportName][associationId] = { [subId]: { ...defaults } }
      }

      savedSummaries[baseReportName][associationId][subId][summaryId] = summary
    } else {
      savedSummaries[baseReportName][summaryId] = summary
    }

    state.summaries = savedSummaries
  },
  [actionNames.GET_SUMMARY_FAILED](state, { baseReportName, summary }) {
    const { associationId, subId, summaries, summaryDefaults } = state

    const savedSummaries = { ...summaries }
    const { id: summaryId } = summary

    summary.isLoading = true
    summary.didFail = false

    if (associationId) {
      if (!savedSummaries[baseReportName][associationId]) {
        const defaults = summaryDefaults[baseReportName]

        savedSummaries[baseReportName][associationId] = { ...defaults }
      }

      savedSummaries[baseReportName][associationId][subId][summaryId] = summary
    } else {
      savedSummaries[baseReportName][summaryId] = summary
    }

    state.summaries = savedSummaries
  },

  [actionNames.GET_SUMMARIES_REQUESTED](state, { baseReportName, summaryRequests }) {
    const { associationId, subId, summaries, summaryDefaults } = state
    const savedSummaries = { ...summaries }

    if (associationId) {
      if (!savedSummaries[baseReportName][associationId]) {
        savedSummaries[baseReportName][associationId] = { [subId]: { ...summaryDefaults[baseReportName] } }
      } else {
        savedSummaries[baseReportName][associationId][subId] = summaryRequests
      }
    } else {
      savedSummaries[baseReportName] = summaryRequests
    }

    state.summaries = savedSummaries
  },

  navigation(state, navigation) {
    state.navigation = navigation
  },
  searchResults(state, searchResults) {
    state.searchResults = searchResults
  },
  [actionNames.UPDATE_RECENT_SEARCHES](state, searchOption) {
    state.recentSearches.push(searchOption)
  },

  [actionNames.GET_SEARCH_REQUESTED]: (state) => {
    state.isLoadingSearch = true
    state.didLoadSearchFail = false
  },
  [actionNames.GET_SEARCH_SUCCEEDED]: (state, searchResults) => {
    state.isLoadingSearch = false
    state.searchResults = searchResults
  },
  [actionNames.GET_SEARCH_FAILED]: (state, error) => {
    state.isLoadingSearch = false
    state.didLoadSearchFail = error || error === false ? error : true
  },

  [actionNames.UPDATE_SEARCH_TERM]: (state, searchTerm) => {
    state.searchTerm = searchTerm
  },

  showDataFreshnessLegend(state, showDataFreshnessLegend) {
    state.showDataFreshnessLegend = showDataFreshnessLegend
  },
  [actionNames.GET_DATA_REFRESH_REQUESTED](state) {
    state.isLoadingDataRefreshReport = true
    state.didLoadDataRefreshReportFail = false
  },
  [actionNames.GET_DATA_REFRESH_SUCCEEDED](state, dataRefreshReport) {
    state.isLoadingDataRefreshReport = false
    state.dataRefreshReport = dataRefreshReport
  },
  [actionNames.GET_DATA_REFRESH_FAILED](state, error) {
    state.isLoadingDataRefreshReport = false
    state.didLoadDataRefreshReportFail = error || error === false ? error : true
  },

  [actionNames.GET_DATA_REFRESHED_TIME_REQUESTED](state) {
    state.isLoadingDataRefreshedTime = true
    state.didLoadDataRefreshedTimeFail = false
  },
  [actionNames.GET_DATA_REFRESHED_TIME_SUCCEEDED](state, items) {
    state.isLoadingDataRefreshedTime = false

    const maxDateDefault = '2001-01-01'

    const getMaxDate = (maxDate, lineItem) => {
      const { dataRefreshedTime } = lineItem

      // TODO: Take time into account when evaluating getMaxDate.
      if (dates.areDatesGte(dataRefreshedTime, maxDate)) {
        maxDate = dataRefreshedTime
      }

      return maxDate
    }

    const maxDate = items.reduce(getMaxDate, maxDateDefault)
    const today = dates.get()
    const noDateFound = maxDate === maxDateDefault

    // Why do we subtract one hour when formatting dataRefreshedTime?
    state.dataRefreshedTime = (noDateFound && 'Date Not Found') || dates.getDataFreshnessDateTime(maxDate)

    state.isDataFresh = !noDateFound && dates.areDatesEqual(today, maxDate)
  },
  [actionNames.GET_DATA_REFRESHED_TIME_FAILED](state, error) {
    state.isLoadingDataRefreshedTime = false
    state.didLoadDataRefreshedTimeFail = error || error === false ? error : true
  },
}

export default mutations
